import { journey } from "../../data/journey";
import Reveal from "../ui/Reveal";
import SectionHeading from "../ui/SectionHeading";

const kindStyles = {
  Education: "bg-pine text-mint",
  Experience: "bg-moss text-cream",
  Training: "bg-frost text-pine",
  Certificate: "bg-white text-moss border border-moss/20",
};

const Journey = () => (
  <section id="journey" className="section bg-cream">
    <div className="pointer-events-none absolute -left-32 bottom-20 h-[400px] w-[400px] rounded-full glow-frost" />

    <div className="shell relative">
      <SectionHeading
        index="04"
        eyebrow="Journey"
        title="Education, practice and"
        accent="everything in between."
        intro="A steady line from computer science fundamentals to shipping real products — with the certificates picked up along the way."
        tone="light"
      />

      <div className="relative mt-16">
        {/* the spine */}
        <div className="absolute left-[9px] top-2 h-full w-px bg-gradient-to-b from-moss/40 via-moss/20 to-transparent md:left-[189px]" />

        <div className="space-y-10">
          {journey.map((item, index) => (
            <Reveal key={item.title} delay={0.05 * index} from="right">
              <div className="group grid gap-4 md:grid-cols-[180px_1fr] md:gap-0">
                <p className="order-2 font-mono text-[12px] uppercase tracking-[0.16em] text-moss/70 md:order-1 md:pr-10 md:pt-1 md:text-right">
                  {item.period}
                </p>

                <div className="relative order-1 pl-9 md:order-2 md:pl-10">
                  <span className="absolute left-0 top-2 flex h-[19px] w-[19px] items-center justify-center rounded-full border border-moss/30 bg-cream transition-transform duration-300 group-hover:scale-110">
                    <span className="h-[7px] w-[7px] rounded-full bg-moss" />
                  </span>

                  <div className="rounded-2xl border border-ink/[0.07] bg-white/70 p-6 transition duration-500 group-hover:-translate-y-1 group-hover:border-moss/20 group-hover:bg-white group-hover:shadow-lift sm:p-7">
                    <div className="flex flex-wrap items-center gap-3">
                      <span
                        className={`rounded-full px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.14em] ${
                          kindStyles[item.kind] || kindStyles.Certificate
                        }`}
                      >
                        {item.kind}
                      </span>
                      <span className="text-[13px] font-medium text-stone">
                        {item.org}
                      </span>
                    </div>

                    <h3 className="mt-4 font-display text-xl leading-snug text-ink sm:text-2xl">
                      {item.title}
                    </h3>

                    <p className="mt-3 text-[14.5px] leading-7 text-stone">
                      {item.note}
                    </p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Journey;
